import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import OnboardingDetailScreen from "../screens/OnboardingDetailScreen";
import useCustomTheme from "../utils/hooks/useCustomTheme";

const OnboardingDetailScreenWithTheme = () => {
    const theme = useCustomTheme();

    return (
        <ThemeProvider theme={theme}>
            <OnboardingDetailScreen />
        </ThemeProvider>
    );
};

export default OnboardingDetailScreenWithTheme;
